import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function Section({
  children,
  className = '',
  id,
  delay = 0
}: SectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 12
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: 'easeOut'
  }} className={`py-16 md:py-24 px-6 lg:px-8 max-w-4xl mx-auto ${className}`} data-id="element-179">
      {children}
    </motion.section>;
}